import React from 'react';
import { UnControlled as CodeMirror } from 'react-codemirror2';
import 'codemirror/mode/yaml/yaml';
// import 'codemirror/addon/hint/javascript-hint';
// import 'codemirror/addon/hint/show-hint';
// import 'codemirror/addon/hint/show-hint.css';
import { ReactComponent as Wc } from './wc.svg';
import './index.css';

const options = {
  lineNumbers: false,
  tabSize: 2,
  mode: 'yaml',
  theme: 'dracula',
  scrollBarStyle: null,
  viewportMargin: Infinity,
  lineWrapping: true,
  extraKeys: {
    'Shift-Tab': 'indentLess',
  },
  // negative values removes the cursor, undefined means default (530)
  // cursorBlinkRate: this.props.readOnly ? -1 : undefined,
  // needs to be able to refresh every 16ms to hit 60 frames / second
  pollInterval: 16,
};

export class WindowControls extends React.Component {
  render() {
    return (
      <div className="wc">
        <Wc />
      </div>
    );
  }
}

export default class CodeMirrorEditor extends React.Component {
  render() {
    return (
      <CodeMirror
        className="cm-editor"
        value={this.props.value || ''}
        options={options}
        onChange={(editor, data, value) => this.props.onChange(value)}
      />
    );
  }
}
